import { XIcon } from "@heroicons/react/solid";
import "../components/orders_mobile.css";
import { FunctionComponent, useEffect, useState } from "react";
import { OrderByItemModel } from "../../../../service/models/orders/order_model";
import {
  OrderType,
  ACTION,
  MODULE,
  OrderStatus,
  PaymentStatus,
} from "../../../../utils/enums";
import LoadingWidget from "../../../components/loading_spinner";
import Loader from "../../../new_components/common/loader";
import EmptyState from "../../../new_components/common/empty_state";
import ModalDialog from "../../../new_components/common/modal";
import FilterWidget from "./components/filter_widget";
import Pagination from "../../../new_components/common/pagination";
import OrderTableWidget from "./components/table";
import OrderComments from "./components/order_comments";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../new_components/common/drawer_modal";
import {
  GetOrdersApi,
  UpdateOrderDetailApi,
} from "../../../../service/repos/order_repo";
import BulkApproveUploadModal from "./components/bulk_approve_upload_modal";
import {
  GetProductsApi,
  GetStatesApi,
} from "../../../../service/repos/products_repo";
import ExportWidget from "./components/export_widget";
import ProductModel from "../../../../service/models/product_model";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";
import Icon from "@mdi/react";
import {
  mdiFileDownloadOutline,
  mdiFileUploadOutline,
  mdiFilterOutline,
  mdiFilterRemoveOutline,
  mdiMenuDown,
  mdiMenuUp,
  mdiReload,
} from "@mdi/js";
import SearchFieldWidget from "../../../new_components/search_field";
import FilterDropDown from "../../../new_components/common/filter_drop_down";
import {
  useToast,
  ToastType,
} from "../../../../context_providers/toast/toast_ctx";
import ActionHistory from "./components/history_logs";
import { UTCToLocalDate } from "../../../../utils/date_util";
import { useAuth } from "../../../../context_providers/auth/authProvider";
import { fetchPost } from "../../../../service/api_client";
import WarehouseSearchField from "../../../../erp/inventory/warehouse/warehouse_search_field";
import { WarehouseModel } from "../../../../erp/inventory/models/warehouse_model";
interface OrderListFilter {
  page?: number;
  count?: number;
  search?: string;
  fromDate?: string;
  toDate?: string;
  state?: string[];
  orderStatus?: string[];
  paymentStatus?: string[];
  saleExecutive?: string[];
  type?: string[];
  items?: string[];
  site_survey?: string[];
  wiring_status?: string[];
  subsidy_status?: string[];
  approval_status?: string;
  createdAtFromDate?: string;
  createdAtToDate?: string;
  stock_outward_status?: string[];
}
interface OrderListPageProps {}
const initialFilter: OrderListFilter = {
  page: 1,
  count: 100,
  orderStatus: [
    OrderStatus.CONFIRMED,
    OrderStatus.DELIVERED,
    OrderStatus.DISPATCHED,
    OrderStatus.INSTALLED,
    OrderStatus.PARTIAL_DELIVERED,
    OrderStatus.WANT_TO_CANCEL,
    OrderStatus.config_pending,
    OrderStatus.hold,
    OrderStatus.write_off,
  ],
};
const OrderListPage: FunctionComponent<OrderListPageProps> = () => {
  const { showToast } = useToast();
  const { isAuthorised } = useAuth();
  const [loading, setLoading] = useState(false);
  const [selectedOrderIds, setSelectedOrderIds] = useState<string[]>([]);
  const tempFilter = localStorage.getItem("filter");
  const tempExe = localStorage.getItem("exe");
  const [filter, setFilter] = useState<OrderListFilter>(
    tempFilter ? JSON.parse(tempFilter) : initialFilter,
  );
  const [total, setTotal] = useState(0);
  const [orderBy, setOrderBy] = useState("order_date");
  const [sortOrder, setSortOrder] = useState("desc");
  const [timeStamp, setTimeStamp] = useState("");
  const [orders, setOrders] = useState<OrderByItemModel[]>([]);
  const [showFilter, setShowFilter] = useState(false);
  const [ShowComment, setShowComment] = useState<{ [key: string]: any }>();
  const [ShowHistory, setShowHistory] = useState<{ [key: string]: any }>();
  const [selectedOrder, setSelectedOrder] = useState<OrderByItemModel>();
  const [filterCollaped, setFilterCollapsed] = useState(true);
  const [isOrderApprover, setIsOrderApprover] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approveWarehouse, setApproveWarehouse] =
    useState<WarehouseModel | null>(null);
  const [suggestedTransportMode, setSuggestedTransportMode] = useState("");
  const [warehouseSuggestionRemarks, setWarehouseSuggestionRemarks] =
    useState("");
  const [orderOrgInfo, setOrderOrgInfo] = useState<
    Array<{
      order_id: string;
      org: { name: string; namespace: string } | null;
      warehouse_id: string | null;
      warehouse_name: string | null;
    }>
  >([]);
  const [orgInfoLoading, setOrgInfoLoading] = useState(false);
  const [itemAvailability, setItemAvailability] = useState<
    Record<
      string,
      {
        loading: boolean;
        data: Array<{
          warehouse_id: string;
          warehouse_name?: string;
          available_units: number;
        }>;
      }
    >
  >({});

  const [states, setState] = useState<
    { state_code: string; name: string; id: number }[]
  >([]);
  const [executives, setExecutives] = useState<{ name: string; uid: string }[]>(
    [...(tempExe ? JSON.parse(tempExe) : [])],
  );
  const [products, setProducts] = useState<ProductModel[]>([]);
  const [showExport, setShowExport] = useState(false);
  const [showApprovalExport, setShowApprovalExport] = useState(false);
  const [showApprovalUpload, setShowApprovalUpload] = useState(false);
  const [analytics, setAnalytics] = useState<{
    total_orders: number;
    total: number;
    subtotal: number;
    discount: number;
    addition: number;
    paid: number;
    qty: number;
    delivered_qty: number;
    installed_qty: number;
    returned_qty: number;
    net_qty: number;
  }>();
  const [exportAllData, setExportAllData] = useState(false);

  const getStates = async () => {
    const res = await GetStatesApi();
    if (res)
      setState(
        res.data.map((f) => {
          f.name = f.name.toUpperCase();
          return f;
        }),
      );
  };

  const getproducts = async () => {
    const res = await GetProductsApi();
    if (res) setProducts(res.data ?? []);
  };

  const getOrders = async () => {
    setLoading(true);
    if (filter.fromDate) {
      filter.fromDate = UTCToLocalDate(filter.fromDate) as any;
    }
    if (filter.toDate) {
      filter.toDate = UTCToLocalDate(filter.toDate) as any;
    }
    const res = await GetOrdersApi({
      ...filter,
      order_by: orderBy,
      sort_order: sortOrder,
    });

    if (res.success) {
      setTimeStamp(res.timeStamp);
      setOrders(res.data.orders);
      if (res.data.metadata) setTotal(res.data.metadata.total);

      setAnalytics(res.analytics);
    } else {
      showToast({
        type: ToastType.error,
        text: res.error,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    localStorage.setItem("filter", JSON.stringify(filter));
    localStorage.setItem("exe", JSON.stringify(executives));

    getOrders();
    if (states.length === 0) getStates();
    if (products.length === 0) getproducts();
  }, [filter, orderBy, sortOrder]);

  const onOrderDetailChanged = async (data: { [key: string]: any }) => {
    setLoading(true);
    const res = await UpdateOrderDetailApi({
      ...data,
      order_id: ShowComment!.order_id,
    });
    if (res.success) {
      setOrders((o) => {
        return o.map((ord) => {
          if (ord.order_id === ShowComment!.order_id) {
            return { ...ord, ...data };
          }
          return ord;
        });
      });
    } else showToast({ type: ToastType.error, text: res.error ?? "" });
    setLoading(false);
  };

  const fetchOrgInfo = async () => {
    if (selectedOrderIds.length === 0) return;
    setOrgInfoLoading(true);
    try {
      const res = await fetchPost(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/orders/orgs-by-ids`,
        { order_ids: selectedOrderIds },
      );
      if (res.success) {
        setOrderOrgInfo(res.data ?? []);
      }
    } catch {}
    setOrgInfoLoading(false);
  };

  const FIXED_WAREHOUSE_IDS = [
    "WRH-938723",
    "WRH-981795",
    "WRH-028178",
    "WRH-144909",
    "WRH-885247", // Kazam Begur Warehouse
  ];

  const fetchItemAvailability = async () => {
    // Collect unique item_codes from selected orders
    const selectedOrders = orders.filter((o) =>
      selectedOrderIds.includes(o.order_id),
    );
    const itemCodes = new Set<string>();
    for (const ord of selectedOrders) {
      for (const p of ord.products ?? []) {
        if (p?.item?.item_code) itemCodes.add(p.item.item_code);
      }
      for (const rm of ord.raw_materials ?? []) {
        if (rm?.item?.item_code) itemCodes.add(rm.item.item_code);
      }
    }

    const codes = Array.from(itemCodes);
    if (!codes.length) return;

    // Set all to loading
    const initial: typeof itemAvailability = {};
    for (const c of codes) initial[c] = { loading: true, data: [] };
    setItemAvailability(initial);

    // Fetch all in parallel
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/items/warehouses/availability`;
    await Promise.all(
      codes.map(async (code) => {
        try {
          const res = await fetchPost(url, {
            warehouse_ids: FIXED_WAREHOUSE_IDS,
            item_code: code,
          });
          if (res.success) {
            setItemAvailability((prev) => ({
              ...prev,
              [code]: {
                loading: false,
                data: (res.result ?? []).map((r: any) => ({
                  warehouse_id: r.warehouse_id,
                  warehouse_name: r.warehouse_name,
                  available_units: r.available_units,
                })),
              },
            }));
          }
        } catch {
          setItemAvailability((prev) => ({
            ...prev,
            [code]: { loading: false, data: [] },
          }));
        }
      }),
    );
  };

  // Check if all items across selected orders are available in the chosen warehouse
  const isWarehouseValid = (): boolean => {
    if (!approveWarehouse) return false;
    const whId = approveWarehouse.id;

    // Collect all item_codes with total required qty across selected orders
    const requiredByCode = new Map<string, number>();
    for (const orderId of selectedOrderIds) {
      const ord = orders.find((o) => o.order_id === orderId);
      if (!ord) continue;
      for (const it of [
        ...(ord.products ?? []),
        ...(ord.raw_materials ?? []),
      ]) {
        const code = it?.item?.item_code;
        if (!code) continue;
        requiredByCode.set(
          code,
          (requiredByCode.get(code) ?? 0) + (it.qty ?? 0),
        );
      }
    }

    // Check every item has enough stock in the selected warehouse
    for (const [code, requiredQty] of requiredByCode) {
      const entry = itemAvailability[code];
      if (!entry || entry.loading) return false;
      const whEntry = entry.data.find((r) => r.warehouse_id === whId);
      if (!whEntry || whEntry.available_units < requiredQty) return false;
    }
    return requiredByCode.size > 0;
  };

  const openApproveModal = () => {
    setShowApproveModal(true);
    setApproveWarehouse(null);
    setSuggestedTransportMode("");
    setWarehouseSuggestionRemarks("");
    fetchOrgInfo();
    fetchItemAvailability();
  };

  const handleApproveOrders = async () => {
    if (selectedOrderIds.length === 0) return;

    setLoading(true);
    try {
      const payload: any = { order_ids: selectedOrderIds };
      if (approveWarehouse) {
        payload.warehouse_id = approveWarehouse.id;
        payload.warehouse_name = approveWarehouse.name;
      }
      if (suggestedTransportMode) {
        payload.suggested_transport_mode = suggestedTransportMode;
      }
      if (warehouseSuggestionRemarks.trim()) {
        payload.warehouse_suggestion_remarks =
          warehouseSuggestionRemarks.trim();
      }
      const res = await fetchPost(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/outward-order-sale-bulk-creation`,
        payload,
      );

      if (res.success) {
        showToast({
          type: ToastType.success,
          text: `Successfully approved ${res.data.insertedCount} orders`,
        });
        setSelectedOrderIds([]);
        setShowApproveModal(false);
        setApproveWarehouse(null);
        setSuggestedTransportMode("");
        setWarehouseSuggestionRemarks("");
        setOrderOrgInfo([]);
        setItemAvailability({});
        getOrders();
      } else {
        showToast({
          type: ToastType.error,
          text: res.error || "Failed to approve orders",
        });
      }
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message || "Error approving orders",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const isexportForAllDataAllowed = isAuthorised({
      module: MODULE.order_export_all,
      action: [ACTION.READ],
    });

    const order_approver_permission = isAuthorised({
      module: MODULE.order_approve,
      action: [ACTION.READ, ACTION.CREATE],
    });

    setExportAllData(isexportForAllDataAllowed);
    setIsOrderApprover(order_approver_permission);
  }, [isAuthorised]);

  return (
    <>
      <div
        className={`orders-mobile-shrink h-max px-3 pt-5 relative md:h-screen h-89  ${
          selectedOrder
            ? "overflow-hidden"
            : "overflow-y-auto overflow-x-hidden"
        }`}
      >
        <div className="flex flex-wrap justify-between  items-end">
          <div className="">
            <h1 className="font-bold text-2xl text-gray-700 border-l-4 border-myPrimaryColor pl-2">
              Orders{" "}
              <span className="text-sm">({analytics?.total_orders})</span>
            </h1>
            <div className="flex gap-2">
              <p className="text-xs text-gray-400">
                Fetched at :{moment(timeStamp).format("hh:mm:ss A")}
              </p>
              <span
                className="transform hover:scale-125 duration-300  cursor-pointer text-gray-400 hover:text-gray-800 "
                onClick={() => {
                  getOrders();
                }}
              >
                <Tooltip title="Refresh">
                  <div className="flex  items-center ">
                    <Icon path={mdiReload} className="w-4 h-4"></Icon>
                  </div>
                </Tooltip>
              </span>
            </div>
          </div>
          <div className="flex gap-2 items-center flex-wrap">
            <SearchFieldWidget
              placeholder="Search order id, name, mobile, email"
              defaulValue={filter.search ?? ""}
              onClear={() => {
                setFilter({ ...filter, search: "" });
                // setSearch("");
              }}
              onSubmit={(search) => {
                if (search) {
                  setFilter({ ...filter, page: 1, search });
                }
              }}
            />
            {isOrderApprover && selectedOrderIds.length > 0 && (
              <button
                onClick={openApproveModal}
                disabled={loading}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 font-semibold text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Assign Warehouse and Approve ({selectedOrderIds.length})
              </button>
            )}
            <div className="flex flex-wrap items-center gap-2">
              {
                <div
                  onClick={() => setShowExport(true)}
                  className=" p-2 duration-300 border   rounded cursor-pointer  hover:bg-gray-800 hover:text-white"
                >
                  <Tooltip title="Download to excel">
                    <div className="flex items-center gap-1 ">
                      <Icon
                        path={mdiFileDownloadOutline}
                        className="w-4 h-4"
                      ></Icon>
                      <p className="text-xs font-semibold">Export</p>
                    </div>
                  </Tooltip>
                </div>
              }
              <div
                onClick={() => setShowApprovalExport(true)}
                className="p-2 duration-300 border rounded cursor-pointer hover:bg-gray-800 hover:text-white"
              >
                <Tooltip title="Export the review sheet (for approval)">
                  <div className="flex items-center gap-1">
                    <Icon path={mdiFileDownloadOutline} className="w-4 h-4" />
                    <p className="text-xs font-semibold">Export for Approval</p>
                  </div>
                </Tooltip>
              </div>
              <div
                onClick={() => setShowApprovalUpload(true)}
                className="p-2 duration-300 border rounded cursor-pointer hover:bg-gray-800 hover:text-white"
              >
                <Tooltip title="Upload reviewed CSV to bulk-approve rows marked 'Approve'">
                  <div className="flex items-center gap-1">
                    <Icon path={mdiFileUploadOutline} className="w-4 h-4" />
                    <p className="text-xs font-semibold">Upload Approval</p>
                  </div>
                </Tooltip>
              </div>
            </div>

            <div className="flex gap-2">
              <h6 className="font-normal">Filters</h6>
              <div
                onClick={() => setFilterCollapsed(!filterCollaped)}
                className="flex   items-center justify-center bg-gray-200 p-1 rounded-full hover:bg-gray-800 hover:text-white"
              >
                <Icon
                  path={filterCollaped ? mdiMenuDown : mdiMenuUp}
                  className="w-4 h-4"
                />
              </div>
            </div>
          </div>
        </div>

        {!filterCollaped && (
          <div className="rounded-lg border border-gray-300 shadow-sm bg-white p-4 grid grid-cols-1 md:grid-cols-12 gap-3 mt-2">
            <div className="col-span-2">
              <FilterDropDown
                placeholder="Order Type"
                onClearAll={() =>
                  setFilter({
                    ...filter,
                    type: undefined,
                  })
                }
                onDelete={(type) => {
                  setFilter({
                    ...filter,
                    type: filter.type?.filter((val) => val !== type),
                  });
                }}
                onSelect={(type) => {
                  setFilter({
                    ...filter,
                    type: [...(filter.type ?? []), type],
                  });
                }}
                selectedOptions={filter.type}
                options={Object.values(OrderType).map((t) => ({
                  label: t,
                  value: t,
                }))}
              />
            </div>
            <div className="col-span-2">
              <FilterDropDown
                placeholder="Products"
                onClearAll={() =>
                  setFilter({
                    ...filter,
                    items: undefined,
                  })
                }
                onDelete={(item) => {
                  setFilter({
                    ...filter,
                    items: filter.items?.filter((val) => val !== item),
                  });
                }}
                onSelect={(item) => {
                  setFilter({
                    ...filter,
                    items: [...(filter.items ?? []), item],
                  });
                }}
                selectedOptions={filter.items}
                options={products.map((p) => ({
                  label: p.name,
                  value: p.id,
                }))}
              />
            </div>{" "}
            <div className="col-span-2">
              <FilterDropDown
                placeholder="Order status"
                onClearAll={() =>
                  setFilter({
                    ...filter,
                    orderStatus: undefined,
                  })
                }
                onDelete={(status) => {
                  setFilter({
                    ...filter,
                    orderStatus: filter.orderStatus?.filter(
                      (val) => val !== status,
                    ),
                  });
                }}
                onSelect={(status) => {
                  setFilter({
                    ...filter,
                    orderStatus: [...(filter.orderStatus ?? []), status],
                  });
                }}
                selectedOptions={filter.orderStatus}
                options={Object.values(OrderStatus).map((t) => ({
                  label: t,
                  value: t,
                }))}
              />
            </div>
            <div className="col-span-2">
              <FilterDropDown
                placeholder="Payment status"
                onClearAll={() =>
                  setFilter({
                    ...filter,
                    paymentStatus: undefined,
                  })
                }
                onDelete={(status) => {
                  setFilter({
                    ...filter,
                    paymentStatus: filter.paymentStatus?.filter(
                      (val) => val !== status,
                    ),
                  });
                }}
                onSelect={(status) => {
                  setFilter({
                    ...filter,
                    paymentStatus: [...(filter.paymentStatus ?? []), status],
                  });
                }}
                selectedOptions={filter.paymentStatus}
                options={Object.values(PaymentStatus).map((t) => ({
                  label: t,
                  value: t,
                }))}
              />
            </div>
            <div className="col-span-2">
              <FilterDropDown
                placeholder="Approval status"
                onClearAll={() =>
                  setFilter({
                    ...filter,
                    approval_status: undefined,
                  })
                }
                onDelete={() => {
                  setFilter({
                    ...filter,
                    approval_status: undefined,
                  });
                }}
                onSelect={(status) => {
                  setFilter({
                    ...filter,
                    approval_status: status,
                  });
                }}
                selectedOptions={
                  filter.approval_status ? [filter.approval_status] : undefined
                }
                options={[
                  { label: "Approved", value: "Approved" },
                  { label: "Unapproved", value: "Unapproved" },
                ]}
              />
            </div>
            <div className="col-span-2">
              <FilterDropDown
                placeholder="Order Status"
                onClearAll={() =>
                  setFilter({
                    ...filter,
                    stock_outward_status: undefined,
                  })
                }
                onDelete={(status) => {
                  setFilter({
                    ...filter,
                    stock_outward_status: filter.stock_outward_status?.filter(
                      (val) => val !== status,
                    ),
                  });
                }}
                onSelect={(status) => {
                  setFilter({
                    ...filter,
                    stock_outward_status: [
                      ...(filter.stock_outward_status ?? []),
                      status,
                    ],
                  });
                }}
                selectedOptions={filter.stock_outward_status}
                options={[
                  "Doc Pending",
                  "Dispatched",
                  "Cancelled",
                  "Device Allocation Pending",
                  "Ready To Dispatch",
                  "WH Yet To Be Assigned",
                  "Tracking ID Pending",
                ].map((s) => ({
                  label: s,
                  value: s,
                }))}
              />
            </div>
            <div className="col-span-3">
              <div className="flex gap-2 items-end">
                <div className="flex-1">
                  <label className="text-xs text-gray-500 mb-1 block">
                    Created From
                  </label>
                  <input
                    className="border rounded text-sm w-full h-8 px-1"
                    type="date"
                    value={filter.createdAtFromDate ?? ""}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        page: 1,
                        createdAtFromDate: e.target.value || undefined,
                      })
                    }
                  />
                </div>
                <div className="flex-1">
                  <label className="text-xs text-gray-500 mb-1 block">
                    Created To
                  </label>
                  <input
                    className="border rounded text-sm w-full h-8 px-1"
                    type="date"
                    value={filter.createdAtToDate ?? ""}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        page: 1,
                        createdAtToDate: e.target.value || undefined,
                      })
                    }
                  />
                </div>
              </div>
              {(filter.createdAtFromDate || filter.createdAtToDate) && (
                <div className="flex mt-1 items-center gap-1 flex-wrap">
                  {filter.createdAtFromDate && (
                    <div className="text-xs font-semibold bg-gray-200 rounded-3xl pl-2 py-1 flex items-center">
                      {moment(filter.createdAtFromDate, "YYYY-MM-DD").format(
                        "DD-MM-YYYY",
                      )}
                      <XIcon
                        className="h-4 w-4 hover:bg-gray-400 hover:text-white p-1 rounded-full mx-1 cursor-pointer"
                        onClick={() =>
                          setFilter({
                            ...filter,
                            createdAtFromDate: undefined,
                          })
                        }
                      />
                    </div>
                  )}
                  {filter.createdAtToDate && (
                    <div className="text-xs font-semibold bg-gray-200 rounded-3xl pl-2 py-1 flex items-center">
                      {moment(filter.createdAtToDate, "YYYY-MM-DD").format(
                        "DD-MM-YYYY",
                      )}
                      <XIcon
                        className="h-4 w-4 hover:bg-gray-400 hover:text-white p-1 rounded-full mx-1 cursor-pointer"
                        onClick={() =>
                          setFilter({
                            ...filter,
                            createdAtToDate: undefined,
                          })
                        }
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="flex flex-col   gap-2">
              <div
                className={`flex items-center justify-center p-2 duration-300 border hover:bg-gray-800 hover:text-white rounded cursor-pointer `}
                onClick={() => setFilter({ ...initialFilter })}
              >
                <Tooltip title="Reset filter">
                  <div className="flex gap-1 items-center justify-center ">
                    <Icon path={mdiFilterRemoveOutline} className="w-4 h-4" />
                    <p className="text-xs font-semibold">Reset</p>
                  </div>
                </Tooltip>
              </div>
              <div
                onClick={() => setShowFilter(true)}
                className="flex items-center p-2 justify-center  duration-300 border hover:bg-gray-800 hover:text-white rounded cursor-pointer  "
              >
                <Tooltip title="More filter">
                  <div className="flex gap-1 items-center justify-center">
                    <Icon path={mdiFilterOutline} className="w-4 h-4" />
                    <p className="text-xs font-semibold">More</p>
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        )}

        {orders.length > 0 ? (
          <>
            <OrderTableWidget
              isOrderApprover={isOrderApprover}
              analytics={analytics}
              selectedOrderIds={selectedOrderIds}
              onSelectOrder={(orderId) => {
                setSelectedOrderIds((prev) => {
                  if (prev.includes(orderId)) {
                    return prev.filter((id) => id !== orderId);
                  } else {
                    if (prev.length >= 10) {
                      showToast({
                        type: ToastType.error,
                        text: "Maximum 10 orders can be selected",
                      });
                      return prev;
                    }
                    return [...prev, orderId];
                  }
                });
              }}
              onSort={(order_by) => {
                if (orderBy !== order_by) {
                  setSortOrder("asc");
                  setOrderBy(order_by);
                } else {
                  if (sortOrder === "asc") setSortOrder("desc");
                  else setSortOrder("asc");
                }
              }}
              onOrderClick={(order) => {
                setSelectedOrder(order);
              }}
              onShowHistory={(order) => setShowHistory(order)}
              onShowComment={(order) => setShowComment(order)}
              orders={orders}
              order_by={orderBy}
              sort_order={sortOrder}
            />
            <div className="mt-2">
              <Pagination
                itemCount={orders.length}
                page={filter.page ?? 1}
                total={total}
                count={filter.count ?? 100}
                onChange={(page) => {
                  setFilter((old) => ({ ...old, page }));
                }}
              />
            </div>
          </>
        ) : !loading ? (
          <EmptyState
            title="No Orders found !"
            message="Try adjusting your search or filters."
            imageSrc="/images/nodata.png"
          />
        ) : (
          <div className="w-full flex flex-col justify-center items-center py-16 text-gray-500 gap-3">
            <Loader />
            <span className="text-sm">Loading orders…</span>
          </div>
        )}
      </div>
      {ShowHistory && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={ShowHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="History"
        >
          <ActionHistory order_id={ShowHistory.order_id} />
        </DrawerModal>
      )}
      {showExport && (
        <ModalDialog
          show={showExport}
          onClose={() => setShowExport(false)}
          title="Export Order Data"
        >
          <ExportWidget filter={filter} exportAllData={exportAllData} />
        </ModalDialog>
      )}
      {showApprovalExport && (
        <ModalDialog
          show={showApprovalExport}
          onClose={() => setShowApprovalExport(false)}
          title="Export Orders for Approval"
        >
          <ExportWidget
            approvalFormat
            filter={filter}
            exportAllData={exportAllData}
          />
        </ModalDialog>
      )}
      <BulkApproveUploadModal
        open={showApprovalUpload}
        onClose={() => setShowApprovalUpload(false)}
        onDone={() => getOrders()}
      />
      {ShowComment && (
        <DrawerModal
          onClose={() => setShowComment(undefined)}
          title=""
          show={ShowComment !== undefined}
          location={DrawerModalLoaction.right}
        >
          <OrderComments
            onRemarkChange={onOrderDetailChanged}
            order={{
              order_id: ShowComment.order_id,
              hold_remark: ShowComment.hold_remark,
              registration_remark: ShowComment.registration_remark,
              remark: ShowComment.remark,
              subsidy_status: ShowComment.subsidy_status,
            }}
            // onClose={(v) => setShowComment(undefined)}
            // show={ShowComment !== undefined}
          />
        </DrawerModal>
      )}

      {showFilter && (
        <DrawerModal
          onClose={() => setShowFilter(false)}
          title="Filter"
          show={showFilter}
          location={DrawerModalLoaction.right}
        >
          <FilterWidget
            products={products}
            filter={filter}
            onReset={() => setFilter(initialFilter)}
            onSubmit={(data, emps) => {
              setFilter(data);
              setShowFilter(false);
              setExecutives([...emps]);
            }}
            executives={executives}
            states={states}
            onClose={() => setShowFilter(false)}
          />
        </DrawerModal>
      )}
      {loading && <LoadingWidget loading={loading} />}

      {/* Assign Warehouse and Approve Modal */}
      {showApproveModal && (
        <>
          <div
            className="fixed inset-0 bg-black/50 z-40"
            onClick={() => {
              setShowApproveModal(false);
              setApproveWarehouse(null);
              setSuggestedTransportMode("");
              setWarehouseSuggestionRemarks("");
              setOrderOrgInfo([]);
              setItemAvailability({});
            }}
          />
          <div
            className="fixed z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-6"
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: "32rem",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <h2 className="text-lg font-semibold mb-4">
              Assign Warehouse and Approve
            </h2>

            {/* Per-order Organization info — only if any selected order has Finished Goods */}
            {(() => {
              const selectedOrds = orders.filter((o) =>
                selectedOrderIds.includes(o.order_id),
              );
              return selectedOrds.some((o) =>
                (o.products ?? []).some(
                  (p: any) => p?.item?.subcategory === "Finished Goods",
                ),
              );
            })() && (
              <div className="mb-4">
                <label className="text-sm font-semibold text-gray-700 block mb-2">
                  Organization
                </label>
                {orgInfoLoading ? (
                  <p className="text-sm text-gray-400">Loading…</p>
                ) : orderOrgInfo.length === 0 ? (
                  <p className="text-sm text-gray-400">No data</p>
                ) : (
                  <div className="space-y-1 max-h-40 overflow-y-auto">
                    {orderOrgInfo
                      .filter((info) => {
                        const ord = orders.find(
                          (o) => o.order_id === info.order_id,
                        );
                        return (ord?.products ?? []).some(
                          (p: any) => p?.item?.subcategory === "Finished Goods",
                        );
                      })
                      .map((info) => (
                        <div
                          key={info.order_id}
                          className="flex justify-between items-center bg-gray-50 rounded p-2 text-sm"
                        >
                          <span className="font-medium">{info.order_id}</span>
                          {info.org ? (
                            <span className="text-green-700">
                              {info.org.name} ({info.org.namespace})
                            </span>
                          ) : (
                            <span className="text-red-500 text-xs">
                              Org not assigned — assign in Stock Outward Screen
                            </span>
                          )}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            )}

            {/* Available Quantity per order per item */}
            {Object.keys(itemAvailability).length > 0 && (
              <div className="mb-4">
                <label className="text-sm font-semibold text-gray-700 block mb-2">
                  Available Quantity
                </label>
                <div className="space-y-3 max-h-56 overflow-y-auto">
                  {selectedOrderIds.map((orderId) => {
                    const ord = orders.find((o) => o.order_id === orderId);
                    if (!ord) return null;
                    const items = [
                      ...(ord.products ?? []),
                      ...(ord.raw_materials ?? []),
                    ];
                    if (!items.length) return null;
                    return (
                      <div key={orderId} className="bg-gray-50 rounded p-2">
                        <div className="text-xs font-semibold text-gray-700 mb-1">
                          {orderId}
                        </div>
                        {items.map((it, idx) => {
                          const code = it?.item?.item_code;
                          if (!code) return null;
                          const entry = itemAvailability[code];
                          return (
                            <div key={idx} className="ml-2 mb-1 text-xs">
                              <span className="font-semibold">{code}</span>{" "}
                              <span className="text-gray-400">
                                ×{it?.qty ?? 0}
                              </span>
                              {" — "}
                              {!entry || entry.loading ? (
                                <span className="text-gray-400">Loading…</span>
                              ) : entry.data.length === 0 ? (
                                <span className="text-gray-400">No data</span>
                              ) : (
                                entry.data.map((row) => (
                                  <span
                                    key={row.warehouse_id}
                                    className="inline-block mr-2 whitespace-nowrap"
                                  >
                                    <span className="text-gray-500">
                                      {row.warehouse_name ?? row.warehouse_id}:
                                    </span>{" "}
                                    <span
                                      className={
                                        row.available_units > 0
                                          ? "font-semibold text-green-700"
                                          : "font-semibold text-red-500"
                                      }
                                    >
                                      {row.available_units}
                                    </span>
                                  </span>
                                ))
                              )}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Warehouse selection */}
            <div className="mb-4">
              <label className="text-sm font-semibold text-gray-700 block mb-1">
                Select Warehouse
              </label>
              <WarehouseSearchField
                type=""
                value={approveWarehouse || undefined}
                placeholder="Search and select a warehouse"
                onSelect={(w) => setApproveWarehouse(w)}
                onClear={() => setApproveWarehouse(null)}
              />
            </div>

            {/* Suggested mode of transport */}
            <div className="mb-4">
              <label className="text-sm font-semibold text-gray-700 block mb-1">
                Suggest Mode of Transport
              </label>
              <select
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
                value={suggestedTransportMode}
                onChange={(e) => setSuggestedTransportMode(e.target.value)}
              >
                <option value="">-- None --</option>
                <option value="Surface">Surface</option>
                <option value="Air">Air</option>
                <option value="Train">Train</option>
              </select>
            </div>

            {/* Remarks for the warehouse */}
            <div className="mb-4">
              <label className="text-sm font-semibold text-gray-700 block mb-1">
                Remarks
              </label>
              <textarea
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
                rows={2}
                placeholder="Add any remarks for the warehouse"
                value={warehouseSuggestionRemarks}
                onChange={(e) => setWarehouseSuggestionRemarks(e.target.value)}
              />
            </div>

            <p className="text-xs text-gray-500 italic mb-2">
              Note: The same warehouse will be assigned to all the above
              selected orders.
            </p>

            {!!approveWarehouse && !isWarehouseValid() && (
              <p className="text-xs text-orange-500 mb-4">
                Note: Selected warehouse may not have sufficient stock for all
                items. All items of the above selected orders should be
                available in the same warehouse.
              </p>
            )}

            {/* Actions */}
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowApproveModal(false);
                  setApproveWarehouse(null);
                  setSuggestedTransportMode("");
                  setWarehouseSuggestionRemarks("");
                  setOrderOrgInfo([]);
                  setItemAvailability({});
                }}
                className="px-4 py-2 border border-gray-300 rounded text-sm font-semibold text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleApproveOrders}
                disabled={
                  loading || (!!approveWarehouse && !isWarehouseValid())
                }
                className="px-4 py-2 bg-green-600 text-white rounded font-semibold text-sm hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Approve
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default OrderListPage;
